import app from './app'
import api from './api'

export default {
  app,
  api,
}
